<template>
    <v-expansion-panels v-if="currentTask > 0">
        <v-expansion-panel v-if="proceduresStore.taskSteps">
        <!--    <v-expansion-panel-header class="procedure-expansion-panel-header"> -->
                <v-stepper
                    non-linear
                    v-model="currentTask"
                    :value="currentTask"
                    class="custom-stepper"
                >
                    <v-stepper-header>
                        <template v-for="(step, index) in proceduresStore.taskSteps">
                            <v-stepper-step color="main_color" :step="index + 1" :key="'stepper_'+index" :complete="(index + 1) < currentTask">
                                <template v-if="currentTask === (index +1)">
                                    {{ step.formulario_nombre }}
                                </template>

                            </v-stepper-step>

                            <v-divider :key="'divider_'+index"></v-divider>
                        </template>

                        <v-stepper-step color="main_color" :step="proceduresStore.taskSteps.length + 1">
                            <template v-if="currentTask == (proceduresStore.taskSteps.length + 1)">
                                Confirmación
                            </template>
                        </v-stepper-step>
                    </v-stepper-header>
                </v-stepper>
          <!--  </v-expansion-panel-header> -->
         <!--   <v-expansion-panel-content>
                <v-stepper
                    v-model="currentTask"
                    vertical
                    class="custom-stepper"
                >
                    <template v-for="(step, index) in proceduresStore.taskSteps">
                        <v-stepper-step color="main_color"
                            :key="'stepper_'+index"
                            :complete="(index + 1) < currentTask"
                            :step="index + 1"
                        >
                            {{ step.formulario_nombre }}
                        </v-stepper-step>

                        <v-stepper-content :step="index + 1" :key="'divider_'+index">
                        </v-stepper-content>
                    </template>

                    <v-stepper-step color="main_color" :step="proceduresStore.taskSteps.length + 1">
                        Confirmación
                    </v-stepper-step>

                    <v-stepper-content :step="proceduresStore.taskSteps.length + 1">
                    </v-stepper-content>

                </v-stepper>
            </v-expansion-panel-content> -->
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: 'Tasksteps',
        props: ['currentTask'],

        computed: {
            ...mapState({proceduresStore: state => state.procedures}),
        }

    };
</script>
<style>
    .custom-stepper{box-shadow: none}
    .procedure-expansion-panel-header{
        padding: 0 16px 0 0;
    }
</style>
